import { PaintRoller as icon } from "lucide-react"
import edit from "./materials.edit"
import list from "./materials.list"
import show from "./materials.show"
import { MaterialRecord } from "./materials.types"

const crud = (permissions: Record<string, string[]>) => ({
  name: "materials",
  options: { label: "Matériaux" },
  list:
    "materials" in permissions && permissions.materials.includes("list")
      ? list
      : undefined,
  show:
    "materials" in permissions && permissions.materials.includes("show")
      ? show
      : undefined,
  edit:
    "materials" in permissions && permissions.materials.includes("edit")
      ? edit
      : undefined,

  icon,

  recordRepresentation: (record: MaterialRecord): string => record.name,
})

export default crud
